import getBreakpoint from 'utils/getBreakpoint';
import {MESSAGE_TYPES} from 'components/message/Message';
import {DEVICE_TYPE_IS} from 'constants/deviceTypes';
import {
    SET_BREAKPOINT,
    SHOW_GLOBAL_MESSAGE,
    TIME_EXPIRED
} from './globalConstants';



const initialState = {
    breakpoint: getBreakpoint(),
    windowWidth: window.innerWidth,
    breakpointChange: false,
    globalMessageType: MESSAGE_TYPES.HIDDEN,
    deviceType: getDeviceType(getBreakpoint()),
    timeExpired: false
};
const reducer = (state = initialState, action:any) => {
    if (typeof state === 'undefined') {
        return initialState
    }

    const newState = Object.assign({}, state);
    switch (action.type) {
        case SET_BREAKPOINT:
            const breakpoint = action.breakpoint;
            const breakpointChange = breakpoint !== state.breakpoint ? true : false;

            return Object.assign({}, state, {
                breakpoint: action.breakpoint,
                breakpointChange,
                deviceType: getDeviceType(breakpoint)
            });
        case SHOW_GLOBAL_MESSAGE:
            newState.globalMessageType = action.messageType;
            return newState;
        case TIME_EXPIRED:
            return {
                ...newState,
                timeExpired: action.payload
            }
        default:
            return newState;
    }
};

// TODO: put this in a helper function
function getDeviceType(breakpoint:string) {
    let deviceType = DEVICE_TYPE_IS.DESKTOP;
    if (breakpoint === 'sm') {
        deviceType = DEVICE_TYPE_IS.MOBILE;
    } else if (breakpoint === 'md') {
        deviceType = DEVICE_TYPE_IS.TABLET;
    }
    return deviceType;
}

export default reducer;